import React from "react";
import Navbar from "../components/navbar";
import "../css/pricing.css";
import { Helmet } from "react-helmet-async";
import Footer from "../components/footer";

export default function Pricing() {
  // This handles the redirect to Stripe
  const handleCheckout = async (planType) => {
    try {
      const response = await fetch(
        "https://resumify.co.uk/api/create-checkout-session",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ plan: planType }),
          credentials: "include",
        },
      );

      const data = await response.json();

      if (response.status === 401) {
        // They aren't logged in! Redirect them to Auth
        window.location.href = "/auth";
        return;
      }

      if (data.url) {
        window.location.href = data.url; // Redirect to Stripe Checkout
      } else {
        alert("Failed to start checkout. Please try again.");
      }
    } catch (error) {
      console.error("Checkout error:", error);
    }
  };

  return (
    <>
      <Helmet>
        <title>Resumify | Pricing & Plans</title>
        <meta
          name="description"
          content="Check out Resumify's simple, transparent pricing. Build your CV for free with our AI assistant, and only pay when you're ready to download."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://resumify.co.uk/pricing" />
      </Helmet>
      <div className="pricing-page">
        <Navbar />

        <section className="pricing-hero">
          <h1>Simple, Transparent Pricing</h1>
          <p>
            Build your CV for free. Only pay when you're ready to download. No
            hidden fees or subscriptions, transparent and honest.
          </p>
        </section>

        <section className="pricing-cards">
          {/* Tier 1: Free to Build */}
          <div className="price-card">
            <h3>Free</h3>
            <p className="price">£0</p>
            <ul>
              <li>
                <strong>1 Question in Interview Simulator</strong>
              </li>
              <li>Build up to 3 CVs</li>
              <li>Save 3 CVs to account</li>
              <li>Full AI writing assistant</li>
              <li>Preview Mode Only</li>
              <li style={{ color: "#f43f5e" }}>No PDF Export</li>
            </ul>
            <button
              className="price-button secondary"
              onClick={() => (window.location.href = "/builder")}
            >
              Start Building
            </button>
          </div>

          {/* Tier 2: The Token / Credit System */}
          <div className="price-card featured">
            <div className="badge">Most Popular</div>
            <h3>PDF Credit</h3>
            <p className="price">
              £4.99<span>/credit</span>
            </p>
            <ul>
              <li>
                <strong>1 Credit = 1 PDF Download</strong>
              </li>
              <li>Buy credits only as you need them</li>
              <li>Ability to download a saved CV</li>
              <li>Credits never expire</li>
            </ul>
            <button
              className="price-button primary"
              onClick={() => handleCheckout("single_pass")}
            >
              Buy 1 Credit
            </button>
          </div>

          {/* Tier 3: Monthly for Power Users */}
          <div className="price-card">
            <h3>Pro Unlimited</h3>
            <p className="price">
              £14.99<span>/mo</span>
            </p>
            <ul>
              <li>
                <strong>Interview Simulator</strong>
              </li>
              <li>
                <strong>Unlimited PDF downloads</strong>
              </li>
              <li>Unlimited saves to account</li>
              <li>Tailor to unlimited jobs</li>
              <li>Cancel anytime</li>
            </ul>
            <button
              className="price-button secondary"
              onClick={() => handleCheckout("pro")}
            >
              Subscribe
            </button>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}
